<template>
  <!-- <pre v-if="responseData"> Data={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PROJEK BP.1.png"
        alt="PROJEK BP.1"
        class="pbt-image"
      />

      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <div class="project-stats">
        <div class="stat-card red">
          <div class="stat-title">Jumlah Permohonan Projek</div>
          <div class="stat-number">
            {{ project.totalProjectApplications }}
          </div>
        </div>

        <div class="stat-card blue">
          <div class="stat-title">Jumlah Projek Diluluskan</div>
          <div class="stat-number">
            {{ project.projectsApproved }}
          </div>
        </div>

        <div class="stat-card cyan">
          <div class="stat-title">Jumlah Projek Bawah Pemantauan</div>
          <div class="stat-number">
            {{ project.projectsUnderMonitoring }}
          </div>
        </div>

        <div class="stat-card green">
          <div class="stat-title">Jumlah Projek Telah Selesai</div>
          <div class="stat-number">
            {{ project.projectsCompleted }}
          </div>
        </div>
      </div>

      <h2>BILANGAN PROJEK/PBT MENGIKUT STATUS</h2>

      <div class="content-wrapper">
        <div class="traffic-box-container">
          <div class="traffic-box">
            <div class="traffic-image-wrapper">
              <img
                src="@/assets/jkt/PBT/traffic.png"
                alt="Traffic Light"
                class="traffic-light-img"
              />
              <div class="traffic-overlay red1">
                {{ projectStatus.merah }}
              </div>
              <div class="traffic-overlay yellow">
                {{ projectStatus.kuning }}
              </div>
              <div class="traffic-overlay green1">
                {{ projectStatus.hijau }}
              </div>
            </div>

            <div class="traffic-status-list">
              <div class="traffic-status">
                <strong>Projek Status Merah</strong><br />
                (59% & Kebawah)
              </div>
              <div class="traffic-status">
                <strong>Projek Status Kuning</strong><br />
                (60% - 79%)
              </div>
              <div class="traffic-status">
                <strong>Projek Status Hijau</strong><br />
                (80% - 100%)
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pbtpay-status">
        <h2>SENARAI PROJEK SIAP</h2>
        <VTable height="450" class="text-no-wrap">
          <thead>
            <tr>
              <th>No</th>
              <th>No Projek</th>
              <th>Nama Projek</th>
              <th>Skor Projek</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in projekSiap || []" :key="index">
              <td>{{ index + 1 || 0 }}</td>
              <td>{{ item?.num_project || "-" }}</td>
              <td>{{ item?.name_project || "-" }}</td>
              <td>{{ item?.score_project ?? "-" }}</td>
              <td>
                <i
                  class="fa fa-circle"
                  :style="{
                    color: getProjectColor(item?.score_project),
                    fontSize: '25px',
                    marginTop: '2px',
                  }"
                />
              </td>
            </tr>
          </tbody>
        </VTable>
      </div>

      <Update />
    </div>
  </AdminBackground>

  <PrimaryModule />
  <PembangunanMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService";
import { onMounted, ref, reactive } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/i-tegur",
  meta: {
    layout: "blank",
    public: true,
  },
});

const years = ref([]);
const states = ref(["Semua Negeri"]);
const pbt = ref([]);
const councils = ref([]);
const selectedYear = ref(2025);
const selectedsState = ref("Semua Negeri");
const selectedPbt = ref("Semua PBT");

const project = reactive({
  totalProjectApplications: 0,
  projectsApproved: 0,
  projectsUnderMonitoring: 0,
  projectsCompleted: 0,
});

const projectStatus = reactive({
  merah: 0,
  kuning: 0,
  hijau: 0,
});

const {
  loading,
  error,
  httpDelete,
  httpPostPut,
  httpGet,
  httpPost,
  numberWithCommas,
  formatToMillion,
} = useHttpService();

const responseData = ref(null);
const projekResponse = ref(null);
const projekSiap = ref([]);

function getProjectColor(score) {
  const numScore = parseFloat(score);
  if (isNaN(numScore)) return "#6c757d"; // fallback gray for null/invalid

  if (numScore < 60) return "#e3342f"; // red
  if (numScore < 80) return "#f8ac59"; // yellow

  return "#38c172"; // green
}

async function loadDataFromApi(
  year = selectedYear.value,
  state = selectedsState.value,
  pbtValue = selectedPbt.value
) {
  try {
    const plainStates = toRaw(state);
    let queryParams = `year=${year}`;

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach((state) => {
          const stateName =
            typeof state === "string" ? state : state.name || state.value;

          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`;
          }
        });
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`;
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes("Semua PBT")) {
      pbtValue.forEach((pbt) => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`;
      });
    }

    // const url = `pembangunan/smk?${queryParams}`

    // const response = await httpGet(url)

    const url = `https://ejkt.kpkt.gov.my/ebp1/api/pembangunan/ringkasan-projek-status?${queryParams}`;

    const res = await fetch(url);
    const response = await res.json();

    years.value = response.years;

    // Populate states dropdown while excluding "Modified Pbt" and null values
    states.value = ["Semua Negeri"];
    response.states.forEach((state) => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state);
      }
    });

    councils.value = response.councils;
    if (response && response.data && response.data) {
      responseData.value = response;

      const data = response.data;

      projectStatus.merah = parseInt(data.project_status_merah) || 0;
      projectStatus.kuning = parseInt(data.project_status_kuning) || 0;
      projectStatus.hijau = parseInt(data.project_status_hijau) || 0;

      projekSiap.value = data.completed_project_name || [];
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

async function loadDataFromApiProjek() {
  try {
    const res = await fetch(
      "https://ejkt.kpkt.gov.my/ebp1/api/pembangunan/ringkasan-projek-bp1?year=2025"
    );

    const projek = await res.json();

    const data = projek?.data?.data || {};

    projekResponse.value = projek?.data || [];

    project.totalProjectApplications = data.total_project_applications || 0;
    project.projectsApproved = data.projects_approved || 0;
    project.projectsUnderMonitoring = data.projects_under_monitoring || 0;
    project.projectsCompleted = data.projects_completed || 0;
  } catch (err) {
    console.error("loadDataFromApiProjek failed:", err);
    projekResponse.value = [];

    // Optional: reset values on error
    project.total_project_applications = 0;
    project.projects_approved = 0;
    project.projects_under_monitoring = 0;
    project.projects_completed = 0;
  }
}

function handleStateChange() {
  pbt.value = [];

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : [];
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : [];
  }

  // Remove "Semua Negeri" if other states are selected
  if (
    selectedsState.value.includes("Semua Negeri") &&
    selectedsState.value.length > 1
  ) {
    selectedsState.value = selectedsState.value.filter(
      (state) => state !== "Semua Negeri"
    );
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter((pbt) => pbt !== "Semua PBT");
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"];
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"];
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach((state) => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach((councilKey) => {
          const council = councils.value[state][councilKey];
          if (council && council.value) {
            pbt.value.push(council.value);
          }
        });
      }
    });
  }
}

onMounted(() => {
  loadDataFromApi();
  loadDataFromApiProjek();
});

//this is for setting the inital values for pbts as semua negeri id default option for Negeri (state)
watch(
  councils,
  (newValue) => {
    if (newValue) handleStateChange();
  },
  { immediate: true }
);

watch(
  [selectedYear, selectedsState, selectedPbt],
  () => {
    loadDataFromApi(
      selectedYear.value,
      selectedsState.value,
      selectedPbt.value
    );
  },
  { immediate: true }
);
</script>

<style scoped>
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.input-item {
  flex: 1;
  margin-right: 15px;
}

.input-item:last-child {
  margin-right: 0;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
  text-transform: uppercase;
}

/* Table */
.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

th {
  background-color: #fff;
  color: #150069 !important;
  font-size: 0.7rem;
  font-weight: bold;
}

td {
  background-color: #fff;
  color: #333;
  font-size: 0.7rem;
}

/* General table styles */
table {
  border-collapse: collapse;
  inline-size: 100%;
}

th,
td {
  padding: 15px;
  border: 1px solid #ddd;
  text-align: start;
}

.project-stats {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  margin-top: 30px;
}

.stat-card {
  flex: 1 1 22%;
  background-color: #ccc;
  color: white;
  border-radius: 10px;
  padding: 16px 12px;
  text-align: center;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  max-width: 240px;
}

.stat-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 20px;
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.stat-button:hover {
  background-color: #eee;
}

/* Color themes */
.red {
  background-color: #ec5560;
}

.blue {
  background-color: #2083c5;
}

.cyan {
  background-color: #27c8c0;
}

.green {
  background-color: #21b995;
}

.traffic-box-container {
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  max-width: 1000px;
  margin: auto;
}

.traffic-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  margin-top: 20px;
}

.traffic-image-wrapper {
  position: relative;
  width: 220px;
}

.traffic-light-img {
  width: 100%;
  height: auto;
}

.traffic-overlay {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2rem;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.7);
}

.traffic-overlay.red1 {
  top: 15%;
}

.traffic-overlay.yellow {
  top: 42%;
}

.traffic-overlay.green1 {
  top: 72%;
}

.traffic-status-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
  text-align: left;
}

.traffic-status {
  background: #2f2f3f;
  color: white;
  padding: 16px 24px;
  border-radius: 0px;
  min-width: 260px;
  font-size: 1rem;
}

/* Responsive styles */
@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    gap: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .content-wrapper {
    padding: 15px;
  }

  th,
  td {
    font-size: 0.6rem;
    padding: 10px;
  }

  .stat-card {
    flex: 1 1 45%;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 1.2rem;
  }

  th,
  td {
    font-size: 0.5rem;
    padding: 8px;
  }

  .content-wrapper {
    padding: 10px;
  }

  .stat-card {
    flex: 1 1 100%;
  }
}
</style>
